import React from 'react';
import sendToNotifier from '~/_base/functions/errorNotifiers';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      errorInfo: null,
    };
  }

  componentDidCatch(error, errorInfo) {
    // Catch errors in any components below and re-render with error message
    this.setState({ error: error, errorInfo: errorInfo });
    // You can also log error messages to an error reporting service here

    sendToNotifier('LiveView Component: ' + error, errorInfo);
  }

  render() {
    if (this.state.errorInfo) {
      // Error path
      return (
        <div className="errorBoundary">
          <h2>Timetravel is no longer available</h2>
          <p>
            Once confined to fantasy and science fiction, time travel is now
            simply an engineering problem.
          </p>
          <p>
            <a href="/">Return to main menu</a>
          </p>
          <p className="errorInfo">
            {this.state.errorInfo.componentStack.toString()}
          </p>
        </div>
      );
    }
    // Normally, just render children
    return this.props.children;
  }
}
